import { Loader } from '@finam/web-ui-kit';
import React, { useState } from 'react';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';

export const FileLink: React.FC<{ docTitle: string, docId: number }> = (props) => {
    const [loading, setLoading] = useState(false);

    function DownloadDoc(docId: number, token: string): void {
        setLoading(true);
        new WebService(token).DownloadDocument(docId, 0).then(res => {
            var a = document.createElement("a"); //Create <a>
            a.href = res.fileData; //Image Base64 Goes here
            a.download = res.fileName; //File name Here
            a.click(); //Downloaded file
            setLoading(false);
        });
    }

     return (<span>{loading ? <Loader height='1em'/> : <TokenContext.Consumer>{value => <a onClick={() => { DownloadDoc(props.docId, value.token) }}>{props.docTitle}</a>}</TokenContext.Consumer>}</span>);
}